import React, { Component } from 'react';
import { Link } from 'react-router-dom'
import { connect } from 'react-redux';

import AppFrame from './AppFrame';
import Title from '../components/common/Title';
import ActionButton from '../components/common/ActionButton';

const style = {
  centered: {
    display: 'flex',
    flexFlow: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    height: window.innerHeight,
    margin: -60
  },
  welcomeNote: {
    maxWidth: 500,
    textAlign: 'center'
  }
}

class Home extends Component {
  constructor(props) {
    super(props);

    this.state = {
      startButton: require('../resources/images/start-button.png'),
      width: 0,
      height: 0,
    }

    this.handleMouseOver = this.handleMouseOver.bind(this);
    this.handleMouseOut = this.handleMouseOut.bind(this);
  }

  updateWindowDimensions() {
    this.setState({ width: window.innerWidth, height: window.innerHeight });
  }

  componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions.bind(this));
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions.bind(this));
  }

  handleMouseOver() {
    this.setState({
      startButton: require('../resources/images/start-button-hover.png')
    });
  }

  handleMouseOut() {
    this.setState({
      startButton: require('../resources/images/start-button.png')
    });
  }

	render() {
    let targetDevice = 'desktop';
    if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
      targetDevice = 'mobile';
     }
    
		return (
			<AppFrame targetDevice={targetDevice}>
				<div style={style.centered}>
          { this.props.user.userInfo && <Title text1='Welcome' text2={this.props.user.userInfo.firstName}/> }
					<br />
          <p style={style.welcomeNote}>
            <b>{"It’s time to empower your patients/clients!"}</b>
            <br /><br />
            {"In the next 10 minutes, you will create your own Channel App, invite your patients/clients to download it and start communicating with them without adding to your workflow."}
          </p>
          <br />
          <p>Start to create a new Channel?</p>
          <Link to='/create-app'>
            <ActionButton label="Create New Channel" />
          </Link>
				</div>
			</AppFrame>
		);
	}
}


function mapStateToProps({user, message}) {
	return {
    user,
		userId: user.userId,
		userProfile: user.profile,
    notifications: message.notifications,
	}
}

export default connect(mapStateToProps)(Home);



// WEBPACK FOOTER //
// ./src/layout/Home.js